import { render, staticRenderFns } from "./StorageSpaceCreate.vue?vue&type=template&id=6880b66c&"
import script from "./StorageSpaceCreate.vue?vue&type=script&lang=js&"
export * from "./StorageSpaceCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports